module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-2-ef7fa3270658eb22ac69b4d6c63d0287.png";